import type { Violation } from '../api/schemas';

interface Props {
  violations: Violation[];
  emptyText?: string;
}

export function ViolationsTable({ violations, emptyText = 'No violations on file.' }: Props) {
  if (violations.length === 0) {
    return <p className="text-sm text-gray-600">{emptyText}</p>;
  }

  return (
    <>
      {/* Mobile: description + demerit pill per row */}
      <ul className="sm:hidden space-y-3">
        {violations.map((v) => (
          <li key={v.id} className="flex items-start gap-3">
            <span
              className={`flex-shrink-0 inline-flex items-center justify-center w-7 h-7 rounded-full text-xs font-semibold ${
                v.demerits === 0
                  ? 'bg-green-100 text-green-800'
                  : 'bg-red-100 text-red-800'
              }`}
              aria-label={`${v.demerits} demerits`}
            >
              {v.demerits}
            </span>
            <span className="text-sm text-gray-700">{v.description}</span>
          </li>
        ))}
      </ul>

      {/* Tablet+ : 2-column table */}
      <div className="hidden sm:block overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-100">
            <tr>
              <th
                scope="col"
                className="px-4 py-2 text-center text-xs font-medium text-gray-700 uppercase tracking-wider w-32"
              >
                Number of Demerits
              </th>
              <th
                scope="col"
                className="px-4 py-2 text-left text-xs font-medium text-gray-700 uppercase tracking-wider"
              >
                Violation
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {violations.map((v) => (
              <tr key={v.id} className="hover:bg-gray-50">
                <td className="px-4 py-2 whitespace-nowrap text-center">
                  <span
                    className={`inline-flex items-center justify-center w-7 h-7 rounded-full text-xs font-semibold ${
                      v.demerits === 0
                        ? 'bg-green-100 text-green-800'
                        : 'bg-red-100 text-red-800'
                    }`}
                  >
                    {v.demerits}
                  </span>
                </td>
                <td className="px-4 py-2 text-sm text-gray-700">{v.description}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
